import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { NavController } from "@ionic/angular";
import { AccountService } from "../services/account.services";

@Injectable({
    providedIn:'root'
})
export class AuthGuard implements CanActivate {

    constructor(private navCtrl: NavController, private authService: AccountService){}
    
    canActivate() {
        const user= this.authService.userValue;
        if(user){
            return true
        }
        this.navCtrl.navigateForward('/home/sign-in')
        return false;
    }

}